// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import Footer from "./modules/footer";
import Seo from "./modules/seo";
import FAQ from "./modules/faq";
import Video from "./modules/video";
import Forms from "./modules/forms";
import SideNav from "./modules/side-nav";
import NewTechCompare from "./modules/new-tech-compare";

// Autoload modules
const modules = [
  Common,
  Animate,
  Header,
  Lightbox,
  Footer,
  Seo,
  FAQ,
  Video,
  Forms,
  SideNav,
  NewTechCompare
];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import templateHome from "./partials/template-home";
import templateNews from "./partials/template-news";
import singlePost from "./partials/single-post";
import singleProduct from "./partials/single-product";
import category from "./partials/taxonomy-category";
import singleNewMachinery from "./partials/single-new-machinery";
import singleUsedMachinery from "./partials/single-used-machinery";
import templateAbout from "./partials/template-about";
import templateContacts from "./partials/template-contacts";
import templateTraining from "./partials/template-training";
import templateSingleVacancies from "./partials/template-single-vacancies";
import templateSingleService from "./partials/template-single-service";
import templateCompare from "./partials/template-compare";
import templateContactUs from "./partials/template-contact-us";
import singleService from "./partials/single-service";
import taxServiceCategory from "./partials/taxonomy-service_category";
import taxUsedMachineryCat from "./partials/taxonomy-used_machinery_cat";
import taxNewMachineryCategory from "./partials/taxonomy-new_machinery_category";
import singleVacancy from "./partials/single-vacancy";
import wooCheckout from "./partials/woo-checkout";
import wooCart from "./partials/woo-cart";
import taxProductCat from "./partials/taxonomy-product_cat";
import singlePart from "./partials/single-part";

// Populate Router instance with DOM routes
const routes = new Router({
  templateHome,
  templateNews,
  templateAbout,
  templateContacts,
  singlePost,
  category,
  singleNewMachinery,
  singleUsedMachinery,
  singleProduct,
  templateTraining,
  templateSingleVacancies,
  templateSingleService,
  templateContactUs,
  templateCompare,
  singleService,
  taxServiceCategory,
  taxUsedMachineryCat,
  taxProductCat,
  taxNewMachineryCategory,
  singleVacancy,
  singlePart,
  woocommerceCheckout: wooCheckout,
  woocommerceCart: wooCart,
});

// Load Events
$(document).ready(() => routes.loadEvents());
